module.exports = __webpack_public_path__ + "static/img/03.39b7a95a.png";